import React, { FC, useContext, useEffect, useState } from 'react';
import { Box, SxProps, TextField, Typography } from '@mui/material';
import { filterCases } from '../../../investigate/Sidebar/components/CasesSidebar/utils';
import { GlobalContext } from '../../contexts/globalContext';
import { i18n } from '../../i18n/i18n';
import CommonTreeView, { GenericTreeItem } from '../CommonTreeView/CommonTreeView';
import { useDebounce } from '@cellebrite/saas-ui-common';

interface CommonCasesTreeProps {
    action: (item: GenericTreeItem) => void;
    styles?: SxProps;
}

const CommonCasesTree: FC<CommonCasesTreeProps> = ({ action, styles }) => {
    const { casesData } = useContext(GlobalContext);
    const [searchInput, setSearchInput] = useState('');
    const [filteredCases, setFilteredCases] = useState(casesData.cases);

    useEffect(() => {
        setFilteredCases(casesData.cases);
    }, [casesData.cases]);

    const setFilteredCasesHandler = () => {
        if (casesData.cases) setFilteredCases(filterCases(casesData.cases, searchInput));
    };

    useDebounce(setFilteredCasesHandler, [casesData.cases, searchInput], 250);

    return (
        <Box
            sx={{
                width: 280,
                height: 300,
                display: 'flex',
                flexDirection: 'column',
                p: '8px',
                overflow: 'overlay',
                ...styles,
            }}
        >
            <Typography sx={{ pl: 1 }}>{i18n.translate('Select case')}</Typography>
            <TextField
                autoFocus={true}
                fullWidth
                size="small"
                placeholder={i18n.translate('Find case')}
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                sx={{ my: 1, pl: 1 }}
            />

            {filteredCases && casesData.activeCaseId && filteredCases.length > 0 ? (
                <CommonTreeView nodes={filteredCases} onItemClick={action} activeId={casesData.activeCaseId} />
            ) : (
                <Typography>{i18n.translate('No Cases')}</Typography>
            )}
        </Box>
    );
};

export default CommonCasesTree;
